import * as Tag from 'types/Ingredient/Detail/Tag';

export type Type = Tag.Type[];

export function create(): Type {
	return [];
}

export function mapToApi(obj: Type): string[] {
	return obj.map((e) => e.id);
}
